<template>
  <div>
    <ProductsDisplay
      v-if="recommendedProducts && this.$store.getters.getFeaturedProducts && this.$store.getters.getFeaturedProducts.length > 0 && !this.$store.getters.getSearchMode"
      :isLoading="$store.state.isLoading"
      :products="this.$store.getters.getFeaturedProducts"
      :title="translations.recommended"
      :prefix="'featured_'"
      :placeholderCount="1"
      :isCarousel="false"
    />
    <Title v-if="archiveTitle && !this.$store.getters.getSearchMode" :title="translations.archiveTitle" />
    <Title v-if="this.$store.getters.getSearchMode && this.$store.state.filters.keyword != ''"
           :title="translations.searchFor + ' ' + this.$store.state.filters.keyword" />
    <Title v-if="this.$store.getters.isDiscountedProductsPage" :title="translations.discountedProductsTitle" />
    <Title v-if="this.$store.getters.isNewProductsPage" :title="translations.newProductsPageTitle" />
    <ProductsPagination>
      <ProductsLayout />
    </ProductsPagination>
  </div>
</template>

<script>
import ProductsPagination from '@/layouts/archive/pagination/Pagination.vue';
import ProductsLayout from '@/layouts/archive/product-grid/ProductsLayout.vue';
import ProductsDisplay from '@/layouts/single/ProductsDisplay.vue';
import Title from '@/layouts/general-ui/Title.vue';

export default {
  components: {
    ProductsPagination,
    ProductsLayout,
    ProductsDisplay,
    Title
  },
  data() {
    return {
      recommendedProducts: ws_vue_store.archive_featured_products === '1',
      archiveTitle: ws_vue_store.archive_title === '1',
      translations: {
        recommended: ws_vue_store.translations.recommended_products,
        archiveTitle: ws_vue_store.translations.archive_title,
        searchFor: ws_vue_store.translations.search_for,
        discountedProductsTitle: ws_vue_store.translations.discounted_products_page_title,
        newProductsPageTitle: ws_vue_store.translations.new_products_page_title
      }
    };
  },
  created() { },
  methods: {},
};
</script>
